'use strict';

import {settings} from '../../../variables.js'
var apiBaseUrl = settings.apiBaseUrl

angular.
module('core.shop')
    .factory('Variation', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/variation/:objectId', {objectId: '@id'})
    }])
    .factory('Product', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/product/:objectId', {objectId: '@id'})
    }])
    .factory('PromoCode', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/promo-code/:code', {code: '@code'})
    }])
    .factory('Delivery', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/delivery/',
            {
                query: {
                    method: 'GET',
                    isArray: true
                }
            }
        )
    }])
    .factory('Payment', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/payment/',
            {
                query: {
                    method: 'GET',
                    isArray: true
                }
            }
        )
    }])
    .factory('UserPayment', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/payment-status/',
            {
                get: {
                    method: 'GET'
                }
            }
        )
    }])
    .factory('UserPaymentYooKassa', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/payment-yookassa/:objectId/',
            {objectId: '@id'},
            {
                get: {
                    method: 'GET'
                }
            }
        )
    }])
    .factory('PaymentSettings', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/payment-settings/',
            {
                get: {
                    method: 'GET'
                }
            }
        )
    }])
    .factory('OrderShop', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/order/',{},
            {
                save: {
                    method: 'POST'
                }
            }
        )
    }])
    .factory('ShopCart', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/cart/',{},
            {
                save: {
                    method: 'PUT'
                },
                update: {
                    method: 'POST'
                }
            }
        )
    }])
    .factory('ProductBack', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/products/:partSlug/',{},
            {
                query: {
                    method: 'GET',
                    params: {partSlug: '@slug'},
                    isArray: true
                }
            }
        )
    }])
    .factory('CompareCart', ['$resource', function($resource){
        return $resource(apiBaseUrl+'/shop/api/compare-cart/',{},
            {
                save: {
                    method: 'PUT'
                },
                update: {
                    method: 'POST'
                }
            }
        )
    }])
;